<template>
    <div ref="colorpickerList">
        <div v-show="active" :class="{ 'colorpicker': true, 'active': active }">
            <ul class="colorpicker-list">
                <li v-for="(color, key) in colors"
                    :class="{ 'colorpicker-list-item': true, 'selected': color === value }" @click="selectColor(key)">
                    <span :style="{ 'background-color': color }"></span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
  import settings from '@/services/settings'

  export default {
    name: 'ColorPickerWidget',
    created () {
      if (!this.value) {
        this.$emit('input', this.defaultColor)
      }
    },
    destroyed () {
      this.$events.$off('colorpicker-toggle')
    },
    mounted () {
      this.$events.$on('colorpicker-toggle', eventData => this.toggle(eventData))
    },
    props: ['value'],
    watch: {
      value (value) {
        if (!value) {
          this.$emit('input', this.defaultColor)
        }
      }
    },
    data () {
      return {
        active: false,
        defaultColor: '#65CCB8',
        colors: settings.colors
      }
    },
    methods: {
      selectColor (key) {
        this.$emit('input', this.colors[key])
        this.active = false
      },
      toggle (eventData) {
        this.active = !this.active
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/widgets/ColorPickerWidget.vue